import { createEntityAdapter } from '@reduxjs/toolkit';
import { TeamGroup } from '../../domain/interfaces/TeamGroup';

const groupsAdapter = createEntityAdapter<TeamGroup>({
  selectId: (group) => group.id,
  sortComparer: (a, b) => a.createdAt.valueOf() - b.createdAt.valueOf(),
});

export default groupsAdapter;
